/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPlanPriceDto } from './SubscriptionPlanPriceDto';
import {
    SubscriptionPlanPriceDtoFromJSON,
    SubscriptionPlanPriceDtoFromJSONTyped,
    SubscriptionPlanPriceDtoToJSON,
    SubscriptionPlanPriceDtoToJSONTyped,
} from './SubscriptionPlanPriceDto';
import type { SubscriptionPlanAccessDto } from './SubscriptionPlanAccessDto';
import {
    SubscriptionPlanAccessDtoFromJSON,
    SubscriptionPlanAccessDtoFromJSONTyped,
    SubscriptionPlanAccessDtoToJSON,
    SubscriptionPlanAccessDtoToJSONTyped,
} from './SubscriptionPlanAccessDto';

/**
 * 
 * @export
 * @interface SubscriptionPlanDetailsDto
 */
export interface SubscriptionPlanDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsDto
     */
    publicDescription: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsDto
     */
    privateDescription: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanDetailsDto
     */
    acceptingNewSubscribers: boolean;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof SubscriptionPlanDetailsDto
     */
    price?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {SubscriptionPlanAccessDto}
     * @memberof SubscriptionPlanDetailsDto
     */
    access: SubscriptionPlanAccessDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPlanDetailsDto
     */
    allowedLoginMethods: Array<string>;
}

/**
 * Check if a given object implements the SubscriptionPlanDetailsDto interface.
 */
export function instanceOfSubscriptionPlanDetailsDto(value: object): value is SubscriptionPlanDetailsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('publicDescription' in value) || value['publicDescription'] === undefined) return false;
    if (!('privateDescription' in value) || value['privateDescription'] === undefined) return false;
    if (!('acceptingNewSubscribers' in value) || value['acceptingNewSubscribers'] === undefined) return false;
    if (!('access' in value) || value['access'] === undefined) return false;
    if (!('allowedLoginMethods' in value) || value['allowedLoginMethods'] === undefined) return false;
    return true;
}

export function SubscriptionPlanDetailsDtoFromJSON(json: any): SubscriptionPlanDetailsDto {
    return SubscriptionPlanDetailsDtoFromJSONTyped(json, false);
}

export function SubscriptionPlanDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPlanDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'publicDescription': json['publicDescription'],
        'privateDescription': json['privateDescription'],
        'acceptingNewSubscribers': json['acceptingNewSubscribers'],
        'price': json['price'] == null ? undefined : SubscriptionPlanPriceDtoFromJSON(json['price']),
        'access': SubscriptionPlanAccessDtoFromJSON(json['access']),
        'allowedLoginMethods': json['allowedLoginMethods'],
    };
}

export function SubscriptionPlanDetailsDtoToJSON(json: any): SubscriptionPlanDetailsDto {
    return SubscriptionPlanDetailsDtoToJSONTyped(json, false);
}

export function SubscriptionPlanDetailsDtoToJSONTyped(value?: SubscriptionPlanDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'publicDescription': value['publicDescription'],
        'privateDescription': value['privateDescription'],
        'acceptingNewSubscribers': value['acceptingNewSubscribers'],
        'price': SubscriptionPlanPriceDtoToJSON(value['price']),
        'access': SubscriptionPlanAccessDtoToJSON(value['access']),
        'allowedLoginMethods': value['allowedLoginMethods'],
    };
}

